import { Head, Link } from "@inertiajs/react"
import { ChevronLeft } from "lucide-react"
import { AppShell } from "@/components/AppShell"
import { PageHeader } from "@/components/PageHeader"
import { ChannelIcon } from "@/lib/channel-icons"
import { SettingsSubNav } from "../SettingsSubNav"
import { ChannelForm, ChannelData, BuilderMethodsAuthor, KitListOption } from "./ChannelForm"

type Props = {
  channel: ChannelData
  initial_tab?:
    | "details"
    | "scheduling"
    | "publishing"
    | "kit_sending"
    | "kit_html_shell"
    | "kit_promo_box"
  builder_methods_authors?: BuilderMethodsAuthor[]
  kit_segments?: KitListOption[]
  kit_email_templates?: KitListOption[]
}

export default function ChannelsShow({ channel, initial_tab, builder_methods_authors, kit_segments, kit_email_templates }: Props) {
  return (
    <>
      <Head title={channel.name}>
        <meta name="description" content={`Configure channel ${channel.name} in SparkDrop.`} />
        <meta property="og:title" content={channel.name} />
        <meta property="og:description" content={`Configure channel ${channel.name} in SparkDrop.`} />
      </Head>
      <AppShell>
        <PageHeader
          title="Settings"
          description="Configure how SparkDrop talks to the world."
          tabs={<SettingsSubNav active="channels" />}
        />

        <Link
          href="/settings/channels"
          className="mt-6 inline-flex items-center gap-1 text-sm text-ink-muted hover:text-ink-display"
        >
          <ChevronLeft className="h-3 w-3" /> All channels
        </Link>

        <h2 className="mt-3 flex items-center gap-2 text-base font-semibold">
          <ChannelIcon
            channelType={channel.channel_type}
            color={channel.color}
            className="h-5 w-5"
          />
          {channel.name}
        </h2>

        <div className="mt-6">
          <ChannelForm
            channel={channel}
            mode="edit"
            initialTab={initial_tab ?? "details"}
            builderMethodsAuthors={builder_methods_authors}
            kitSegments={kit_segments}
            kitEmailTemplates={kit_email_templates}
          />
        </div>
      </AppShell>
    </>
  )
}
